import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PoliciesFilterStateService {

  status: number = 0;

  reset(): void {
    this.resetStatusFilter();
  }

  resetStatusFilter(): void {
    this.status = 0;
  }
}